const config = {
    "APIs": {
        "getModules": "User/modules",
        "getWidgets": "User/widgets",
    },
    "map": {
		"STUDENT_PORTAL_MODULE": {
            "name":"Student Portal",
            "path":"",
            "showInMenu": false,
		},
    }
}

export default config;